import { render, staticRenderFns } from "./InstagramBusinessChannelStatistics.vue?vue&type=template&id=825ac652"
import script from "./InstagramBusinessChannelStatistics.vue?vue&type=script&lang=js"
export * from "./InstagramBusinessChannelStatistics.vue?vue&type=script&lang=js"
import style0 from "./InstagramBusinessChannelStatistics.vue?vue&type=style&index=0&id=825ac652&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports